import React from "react"
import { Redirect } from "react-router-dom"

export const withSecuredPage = (WrappedPage) => {
  return (props) => {
    let token = sessionStorage.getItem("user_token")

    return token ? <WrappedPage {...props} /> : <Redirect to="/login" />
  }
}
